import React from "react";
import { BatteryCharging } from "lucide-react";

/**
 * What the programme's structure asks of this slot: sets, reps, rest and
 * target, from getSlotRecommendation. Shown before a session is built (what
 * it will be) and on a built one (what it was built to).
 */
const SlotGuide = ({ rec, compact = false }) => {
  if (!rec) return null;
  const stats = [
    ["Sets", rec.sets],
    ["Reps", rec.reps],
    ["Rest", rec.rest],
    ["Target", rec.intensity],
  ].filter(([, v]) => v);

  // One line, for a built session whose plan says the rest (#183).
  if (compact) {
    const line = stats
      .map(([k, v]) => (k === "Target" ? v : `${v} ${k.toLowerCase()}`))
      .join(" · ");
    if (!line && !rec.isDeload) return null;
    return (
      <p className="text-xs leading-relaxed text-muted-foreground">
        {rec.isDeload && (
          <span className="mr-1 inline-flex items-center gap-1 text-yellow-500">
            <BatteryCharging className="h-3.5 w-3.5 shrink-0" />
            Deload week.
          </span>
        )}
        {line && `Built to ${line}.`}
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {rec.isDeload && (
        <p className="flex items-center gap-1.5 text-xs text-yellow-500">
          <BatteryCharging className="h-3.5 w-3.5 shrink-0" />
          Deload week: about half the usual volume, with lighter loads.
        </p>
      )}
      {rec.note ? (
        <p className="text-sm leading-relaxed text-muted-foreground">{rec.note}</p>
      ) : (
        stats.length > 0 && (
          <div className="grid grid-cols-2 gap-2">
            {stats.map(([k, v]) => (
              <div
                key={k}
                className="rounded-lg border border-border bg-background px-2.5 py-2"
              >
                <div className="text-[10px] uppercase tracking-[0.08em] text-muted-foreground">
                  {k}
                </div>
                <div className="text-sm font-semibold text-foreground">{v}</div>
              </div>
            ))}
          </div>
        )
      )}
    </div>
  );
};

export default SlotGuide;
